import { render, staticRenderFns } from "./RateVerificationTable.vue?vue&type=template&id=2245a530&"
import script from "./RateVerificationTable.vue?vue&type=script&lang=js&"
export * from "./RateVerificationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports